/**
 * Sort directions.
 */
export const ColumnSortDirections = Object.freeze({
    Ascending: 'asc',
    Descending: 'desc',
});
